


























import {Component, Prop, Watch} from 'vue-property-decorator';
import BaseComponent from '@/core/components/BaseComponent';
import SystemBarMenu from "@/components/SystemBar/Components/SystemBar-Menu.vue";
import {versions} from "@/versions";
import SystemBarSearch from "@/components/SystemBar/Components/SystemBar-Search.vue";

@Component({
    components: {
        SystemBarSearch,
        SystemBarMenu

    }
})
export default class SystemBar extends BaseComponent {

    // Bindings to parent

    // Bindings to view
    public isReady = false;
    public version = '';

    public mounted() {
        this.renderView();
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    private renderView() {
        this.version = versions.version;
        this.isReady = true;
    }

}
